import { globalStyle, style } from '@vanilla-extract/css';

import columnStyles from '../columnElement/Column.css';
import { listItemElement } from '../listItemElement/ListItem.css';
import rootStyles from '../rootElement/Root.css';

const { rootElement } = rootStyles;

const { columnItemElement } = columnStyles;

export const listElement = style({
  position: 'relative',
  margin: 0,
  padding: '0 30px',
  paddingInlineStart: 24,
  textAlign: 'left',
  width: 'var(--width)',
  maxWidth: 'var(--max-width)',

  selectors: {
    [`${columnItemElement} > &, ${listItemElement} > &`]: {
      width: '100%',
      maxWidth: '100%',
    },
    [`${rootElement} > &`]: {
      paddingInlineStart: 54,
    },
  },
});

const unorderedListElementSelector = `ul${listElement}`;
const orderedListElementSelector = `ol${listElement}`;

globalStyle(`${orderedListElementSelector}`, {
  listStyle: 'decimal outside',
});
globalStyle(`${unorderedListElementSelector}`, {
  listStyle: 'disc outside',
});
globalStyle(`${unorderedListElementSelector} ${unorderedListElementSelector}`, {
  listStyle: 'circle',
});
globalStyle(`${unorderedListElementSelector} ${unorderedListElementSelector} ${unorderedListElementSelector}`, {
  listStyle: 'square',
});
